import React, { useState, useEffect } from "react";

const images = [
  { src: "1.png", caption: "Cloud To Be Architecture Expertise " },
  { src: "2.png", caption: "Hybrid Cloud IAM Excellence" },
  { src: "3.jpg", caption: "Stay Secure with Threat Detection" },
  { src: "4.jpg", caption: "Important & Trusted Partnerships" },
  { src: "5.png", caption: "IAM Identity And Access Management Expertise " },
];

function ImageSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide every 3s
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Responsive styles
  const sliderStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "1500px",
    height: "60vh", // flexible height based on viewport
    minHeight: "650px",
    margin: "50",
    overflow: "hidden",
    borderRadius: "10px",
  };

  const imgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "opacity 1s ease-in-out",
  };

  const captionStyle = {
    position: "absolute",
    bottom: "5%",
    left: "5%",
    background: "rgba(0, 0, 0, 0.4)",
    color: "white",
    padding: "8px 15px",
    borderRadius: "5px",
    fontSize: "clamp(12px, 2vw, 20px)", // scales with screen size
    maxWidth: "90%",
  };

  const btnStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(0,0,0,0.5)",
    color: "white",
    border: "none",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "clamp(14px, 2vw, 22px)",
    borderRadius: "50%",
    zIndex: 10,
  };

  const dotContainerStyle = {
    position: "absolute",
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  };

  const dotStyle = (isActive) => ({
    height: "10px",
    width: "10px",
    borderRadius: "50%",
    background: isActive ? "white" : "gray",
    cursor: "pointer",
    transition: "background 0.3s",
  });

  return (
    <div style={sliderStyle}>
      {images.map((image, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: index === currentIndex ? 1 : 0,
            transition: "opacity 1s ease-in-out",
          }}
        >
          <img src={image.src} alt={image.caption} style={imgStyle} />
          <div style={captionStyle}>{image.caption}</div>
        </div>
      ))}

      {/* Prev/Next Buttons */}
      <button style={{ ...btnStyle, left: "10px" }} onClick={prevSlide}>
        ❮
      </button>
      <button style={{ ...btnStyle, right: "10px" }} onClick={nextSlide}>
        ❯
      </button>

      {/* Dots */}
      <div style={dotContainerStyle}>
        {images.map((_, index) => (
          <div
            key={index}
            style={dotStyle(index === currentIndex)}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default ImageSlider;
